import * as React from 'react'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import { CircleIcon } from 'lucide-react'

import { RadioGroup } from '../ui/radio-group'

import { cn } from '../../lib/utils'

function RadioGroupItem({
  className,
  hideCheckBox = false,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item> & {
  hideCheckBox?: boolean
}) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        'border-input text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 shadow-xs border-button aspect-square size-4 h-6 w-6 shrink-0 rounded-full border border-solid bg-transparent  outline-none transition-[color,box-shadow] focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex items-center justify-center"
      >
        <CircleIcon
          className={cn(
            'fill-primary border-button absolute left-1/2 top-1/2 size-2 h-0 w-0 -translate-x-1/2 -translate-y-1/2 rounded-full border-[6px] border-solid',
            hideCheckBox ? 'border-transparent' : ''
          )}
        />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
}

export { RadioGroup, RadioGroupItem }
